<template>
  <div class="tenant-admin">
    <breadCrumb></breadCrumb>
    <div class="tenant-admin-header">
      <button @click="addTenant">新增内容形态</button>
    </div>
    <!-- 列表 -->
    <div class="tenant-admin-table">
      <el-table :data="tableList">
        <el-table-column prop="name" label="内容形态名称" />
        <el-table-column prop="contentType" label="内容形态Type" />
        <el-table-column prop="contentParagraphTypes" label="内容形态段落" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <span class="border"></span>
              <el-button type="text" size="small" @click="Jumppage(scope.row)"
                >跳转
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <!-- 弹框 -->
    <modal
      :isShow.sync="ifdialogFormVisible"
      :isShowClose="true"
      :title="dialogTitle"
      :btnText="butText"
      :types="types"
      :isShowBtn="isShowBtn"
      :width="width"
      @clickHandler="clickHandler"
    >
      <el-form
        :model="formData"
        label-position="right"
        label-width="120px"
        class="form"
        :rules="rules"
        ref="formData"
      >
        <el-form-item label="内容形态名称" prop="name">
          <el-input
            v-model="formData.name"
            class="dialogInput"
            placeholder="请输入内容形态名称"
            size="small"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="段落" prop="contentParagraphTypes">
          <el-input
            v-model="formData.contentParagraphTypes"
            class="dialogInput"
            placeholder="请输入段落内容，使用英文 , 分割"
            size="small"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination";
import {
  contentTypeUpdate,
  contentTypeManageSave,
} from "../../../../api/admin";
import modal from "../../../../components/modal";
import breadCrumb from "../../../../components/breadCrumb";
import axios from "axios";
export default {
  name: "tenantManagement",
  components: {
    modal,
    pagination,
    breadCrumb,
  },
  watch: {
    "formData.name"(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.name = this.$utils.removalSpace(newValue);
      }
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入内容名称", trigger: "blur" }],
        contentParagraphTypes: [
          { required: true, message: "请输入段落内容", trigger: "blur" },
        ],
      },
      dialogName: "",
      butText: ["取消", "确定"],
      types: ["default", "submit"],
      isShowBtn: [true, true],
      selectList: [],
      formData: {
        name: "",
        contentParagraphTypes: "",
      },
      dialogTitle: "新增内容形态",
      labelWidth: "80px",
      width: "500px",
      ifdialogFormVisible: false,
      tableList: [],
      val: {},
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.contentTypeUpdate();
  },
  methods: {
    // 跳转
    Jumppage() {
      let isDev = process.env.VUE_APP_WIKI == "//beta-api.m.jd.com";
      let vaccinePreview = "https://jdh-mpaas-yf.jd.com/project/appManage"; // mpass预发地址
      let vaccineOnline = "https://jdh-mpaas.jd.com/project/appManage"; // mpass疫苗
      window.open(isDev ? vaccinePreview : vaccineOnline);
    },
    // 新增弹框方法
    clickHandler(val) {
      if (val === "one") {
        // 失败
        this.ifdialogFormVisible = false;
      } else {
        // 成功
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.contentTypeAdd(this.formData);
            this.ifdialogFormVisible = false;
          } else {
            return false;
          }
        });
      }
    },
    // 新增内容 清空输入框 显示弹框
    addTenant() {
      this.formData.name = "";
      this.formData.contentParagraphTypes = "";
      this.ifdialogFormVisible = true;
    },
    // 添加内容列表 请求方法
    contentTypeAdd(val) {
      this.formData.contentParagraphTypes = val.contentParagraphTypes
        .split(",")
        .map((item) => {
          return {
            name: item,
          };
        });
      contentTypeManageSave(this.formData)
        .then((res) => {
          this.contentTypeUpdate();
          this.$message.success("添加成功");
        })
        .catch((err) => {
          this.$message.error("添加失败");
        });
    },
    // 分页方法
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.contentTypeUpdate();
    },
    // 列表查询
    contentTypeUpdate() {
      let vm = this;
      contentTypeUpdate({
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        tenantId: this.$route.query.id,
      })
        .then((res) => {
          vm.tableList = res.data.map((item) => {
            item.contentParagraphTypes =
              item.contentParagraphTypes &&
              item.contentParagraphTypes.length > 0 &&
              item.contentParagraphTypes
                .map((val) => {
                  return val.desc;
                })
                .join(",");
            return item;
          });
          vm.paginationDataProduct.total = res.totalCount;
          vm.paginationDataProduct.currentPage = res.pageNo;
          vm.paginationDataProduct.pageSize = res.pageSize;
        })
        .catch((err) => {
          if (err.code === "1407") {
            this.$message.error(err.msg);
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.tenant-admin-header {
  button {
    width: 120px;
  }
}
.dialogInput {
  width: 300px;
}
.form.el-form.form.el-form--label-right {
  padding-left: 30px;
  margin-top: 30px;
  // padding-right: 40px;
}
:deep(.el-textarea) {
  width: 300px;
  // height: 32px;
}
.el-form :deep(.el-form-item) {
  padding: 5px;
}
:deep(.el-dialog__header) {
  width: 500px;
  height: 46px;
  background: rgba(247, 248, 251, 1);
  border-radius: 4px 4px 0px 0px;

  // width: 32px;
  // height: 22px;
  line-height: 22px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: rgba(51, 56, 64, 1);
  padding: 0;
}
:deep(.el-pagination__editor .is-in-pagination) {
  width: 46px !important;
}
</style>
